import { render, staticRenderFns } from "./TypeInfo.vue?vue&type=template&id=1cd12a9a"
import script from "./TypeInfo.vue?vue&type=script&lang=js"
export * from "./TypeInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports